import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import { Query } from '../types/graphql-types';
import { SocialServiceIcon } from './Icon';

export const FacebookIcon = () => {
  const data: Query = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "facebook.svg" }) {
        publicURL
      }
    }
  `);
  return (
    <SocialServiceIcon src={data!.file!.publicURL as string} title="Facebook" />
  );
};
